const settings = {
    host: 'http://paascloud.net',
    lockr_prefix: 'PASSCLOUD_PAAS_',
    cookie_prefix: 'PASSCLOUD_PAAS_',
    domain: '.paascloud.net',
    secret_key: '^#rwd6Ffz$X5alRN',
    secret: {
        key_str: 'om8q6fq#A0Yl@qJy',
        iv_str: '0#86gzOcsv1bXyIx'
    },
    USER: {
        LOGIN_NAME: 'LOGIN_NAME',
        MENU_LIST: 'MENU_LIST',
        REMEMBER_ME: 'REMEMBER_ME'
    },
    CART: {
        LOGIN_NAME: 'LOGIN_NAME',
        SHOPPING_CART: 'SHOPPING_CART'
    }
}

export {
    settings
}



// WEBPACK FOOTER //
// ./src/util/settings/index.js